import { Box, Card, Grid, Typography } from "@mui/material";
import React, { useState } from "react";

// Placeholder data for tutorials
const TUTORIAL_VIDEOS = [
    {
        id: "1",
        title: "Tutoriel de présentation de la plateforme",
        url: "https://evocoach.nyc3.cdn.digitaloceanspaces.com/assets/evocoach-intro.mp4",
        thumbnail: "",
        description: "Découvrez les fonctionnalités principales de la plateforme."
    },
    {
        id: "2",
        title: "Gérer vos clients",
        url: "https://www.youtube.com/embed/c-L6D_-xzl4",
        thumbnail: "https://img.youtube.com/vi/c-L6D_-xzl4/0.jpg",
        description: "Apprenez à gérer vos clients."
    },
    // {
    //     id: "3",
    //     title: "Gérer vos entraineurs",
    //     url: "https://www.youtube.com/embed/8Dfbk0Zmvvo",
    //     thumbnail: "https://img.youtube.com/vi/8Dfbk0Zmvvo/0.jpg",
    //     description: "Apprenez à gérer vos entraineurs."
    // },
    {
        id: "4",
        title: "Tutoriel exercices",
        url: "https://www.youtube.com/embed/addmfDT5Rnw",
        thumbnail: "https://img.youtube.com/vi/addmfDT5Rnw/0.jpg",
        description: "Apprenez à créer des exercices."
    },
    {
        id: "5",
        title: "Tutoriel séances",
        url: "https://www.youtube.com/embed/n1cCYambLZg",
        thumbnail: "https://img.youtube.com/vi/n1cCYambLZg/0.jpg",
        description: "Apprenez à créer des séances."
    },
    {
        id: "6",
        title: "Tutoriel programme d'entraînement",
        url: "https://www.youtube.com/embed/YO0dDJRpFPE",
        thumbnail: "https://img.youtube.com/vi/YO0dDJRpFPE/0.jpg",
        description: "Apprenez à créer des programmes."
    },
    {
        id: "7",
        title: "Tutoriel recettes",
        url: "https://www.youtube.com/embed/PRWmM-bIQ0g",
        thumbnail: "https://img.youtube.com/vi/PRWmM-bIQ0g/0.jpg",
        description: "Apprenez à créer des recettes."
    },
    {
        id: "8",
        title: "Tutoriel programme de nutrition",
        url: "https://www.youtube.com/embed/z-Brd5VVzs4",
        thumbnail: "https://img.youtube.com/vi/z-Brd5VVzs4/0.jpg",
        description: "Apprenez à créer des programmes de nutrition."
    }
];

const TutorialsPage = () => {
    const [selectedVideo, setSelectedVideo] = useState(TUTORIAL_VIDEOS[0]);
    const [hasClicked, setHasClicked] = useState(false);

    // Helper to ensure watch links are converted to embed links to prevent 'refused to connect'
    const getEmbedUrl = (url) => {
        let embedUrl = url || "";
        if (embedUrl.includes("watch?v=")) {
            embedUrl = embedUrl.replace("watch?v=", "embed/").split("&")[0];
        }

        // Autoplay if a thumbnail has been explicitly clicked
        if (hasClicked) {
            embedUrl += embedUrl.includes("?") ? "&autoplay=1" : "?autoplay=1";
        }

        return embedUrl;
    };

    return (
        <Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: "1200px", margin: "0 auto" }}>
            <Typography variant="h4" sx={{ fontWeight: 600, mb: { xs: 2, sm: 4 }, color: "#111111", fontSize: { xs: "22px", sm: "34px" } }}>
                Tutoriels Vidéo
            </Typography>

            {/* Featured Video Player */}
            <Card
                sx={{
                    mb: { xs: 2, sm: 4 },
                    borderRadius: { xs: "12px", sm: "16px" },
                    overflow: "hidden",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
                    bgcolor: "#000"
                }}
            >
                <Box sx={{ position: "relative", paddingTop: "56.25%", width: "100%" }}>
                    {selectedVideo.url.endsWith(".mp4") ? (
                        <video
                            key={selectedVideo.url}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                            }}
                            src={selectedVideo.url}
                            controls
                            autoPlay={hasClicked}
                        />
                    ) : (
                        <iframe
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                border: 0,
                            }}
                            src={getEmbedUrl(selectedVideo.url)}
                            title={selectedVideo.title}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    )}
                </Box>
                <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: "#fff" }}>
                    <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, fontSize: { xs: "16px", sm: "24px" } }}>
                        {selectedVideo.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ fontSize: { xs: "13px", sm: "16px" } }}>
                        {selectedVideo.description}
                    </Typography>
                </Box>
            </Card>

            {/* Thumbnails Grid */}
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, fontSize: { xs: "15px", sm: "20px" } }}>
                Tous les tutoriels
            </Typography>

            <Grid container spacing={{ xs: 1.5, sm: 3 }}>
                {TUTORIAL_VIDEOS.map((video) => (
                    <Grid item xs={6} sm={6} md={4} lg={3} key={video.id}>
                        <Card
                            onClick={() => {
                                setSelectedVideo(video);
                                setHasClicked(true);
                            }}
                            sx={{
                                cursor: "pointer",
                                borderRadius: "12px",
                                overflow: "hidden",
                                transition: "all 0.2s ease-in-out",
                                border: selectedVideo.id === video.id ? "2px solid #0001FC" : "2px solid transparent",
                                "&:hover": {
                                    transform: "translateY(-4px)",
                                    boxShadow: "0px 12px 24px rgba(0, 0, 0, 0.1)",
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    position: "relative",
                                    paddingTop: "56.25%",
                                    bgcolor: "#f5f5f5",
                                    backgroundImage: `url(${video.thumbnail})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center"
                                }}
                            >
                                {/* Play Icon Overlay */}
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "48px",
                                        height: "48px",
                                        borderRadius: "50%",
                                        bgcolor: "rgba(0, 0, 0, 0.6)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        opacity: selectedVideo.id === video.id ? 1 : 0.8,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 0,
                                            height: 0,
                                            borderTop: "8px solid transparent",
                                            borderBottom: "8px solid transparent",
                                            borderLeft: "12px solid #fff",
                                            ml: "4px" // slight optical adjustment for play triangle
                                        }}
                                    />
                                </Box>
                            </Box>
                            <Box sx={{ p: { xs: 1, sm: 2 }, height: { xs: "72px", sm: "100px" } }}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: { xs: "0.75rem", sm: "0.95rem" },
                                        lineHeight: 1.2,
                                        display: "-webkit-box",
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden"
                                    }}
                                >
                                    {video.title}
                                </Typography>
                            </Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box >
    );
};

export default TutorialsPage;
